import { useSelector } from "react-redux";
import ButtonCustom from "../CustomButtom/ButtonCustom";
import LoadingPortal from "../loadings/LoadingPortal";
import { useState } from "react";
import { DynamicModal } from "../modal/DynamicModal";


export const CardHelpdesk = (props) => {
 
  const values = props.data;   
  const { loadingHD, agente:agentedb, admin: admindb } = useSelector((state) => state.helpdesk);

  const [actionSelected, setActionSelected] = useState(null)
  const [caseSelected, setCaseSelected] = useState({})
  const [isOpenModal, setIsOpenModal] = useState(false)

  let colorCard = {
    "Alta": 'card-danger',
    "Media": 'card-warning',
    "Baja": 'card-info'
  } 
  
  let iconPriority = {
    "Alta": 'fa-exclamation-triangle text-danger',
    "Media": 'fa-exclamation-circle text-warning',
    "Baja": 'fa-circle text-info'
  } 
  
  const openModal = (action, data = {}) => {
    setActionSelected(action)
    setIsOpenModal(true)
    setCaseSelected(data)
  }
  const hideModal = () => {
    setActionSelected(null)
    setIsOpenModal(false)
  }

  return (
    <>
      <DynamicModal 
        handleClose={hideModal}
        action={actionSelected}
        size='modal-lg'
        isOpen={isOpenModal} 
        caseS={caseSelected}
      />


      <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-3'>
        <div
          className={`
            card card-outline p-1  ${colorCard[values?.prioridad_name]}
          `}        
          style={{ cursor: "pointer" }}
        >
          <div 
            className="card-body"          
          >           
            <div className="row">              
              <div className="col-12 px-1">
                {loadingHD ? (            
                  <LoadingPortal isOpen={loadingHD} />
                ) : ( 
                  <>
                    <ul className='list-unstyled'>
                      <li className="text-wrap">
                        <i className='fa fa-circle text-secondary'></i>
                        <span className="font-weight-bold ml-2 text-uppercase">{values?.id}</span>
                      </li>
                      <li className="text-wrap">
                        <i className='fa fa-bookmark text-secondary'></i>
                        <span className="font-weight-bold ml-2 text-uppercase">{values?.title}</span>
                      </li>
                      <li>
                        <i className='fa fa-building text-secondary'></i>
                        <span className="font-weight-bold ml-2">{values?.desc_area}</span>
                      </li>
                      <li>
                        <i className='fa fa-user text-secondary'></i>
                        <span className="font-weight-bold ml-2">{values?.first_name} {values?.last_name}</span>
                      </li>
                      <li>
                        <i className='fa fa-hourglass-end text-secondary'></i>
                        <span className="font-weight-bold ml-2">{values?.name}</span>
                      </li>
                      <li>
                        <i className='fa fa-calendar-day text-secondary'></i>
                        <span className="font-weight-bold ml-2">{values?.created}</span>
                      </li>
                      <li>
                        <i className='fa fa-user-tag text-secondary'></i>
                        <span className="font-weight-bold ml-2">{ values?.agente }</span>
                      </li>
                      <li>
                        <i className={`fa ${iconPriority[values?.prioridad_name]} text-secondary`}></i>
                        <span className="font-weight-bold ml-2">{values?.prioridad_name}</span>
                      </li>                    
                      {/* esto solo es para el agente */}
                      { (agentedb || admindb) && values.cumplimiento && (
                          <li>
                            <i className='fa fa-user-clock text-secondary'></i>
                            <span className="font-weight-bold ml-2">{values.cumplimiento}</span>
                          </li> 
                        )
                      }                   
                    </ul>
                    <div className="col-12 mt-1 border-top pt-2 px-1">
                      <div className="d-flex flex-row flex-wrap">
                        <ButtonCustom 
                          classnames={`btn btn-sm btn-info text-white rounded m-1`}
                          popOver='Bitacora'
                          onClick={() => {
                            if(props.hasOwnProperty('getDetalles')) {
                              props.getDetalles(values.id, values)
                            } 
                          }}
                        >
                          <i className='fa fa-eye'></i>
                        </ButtonCustom>
                        <ButtonCustom 
                          classnames={`btn btn-sm btn-warning2 text-white rounded m-1`} 
                          popOver='Tomar Caso'
                          style={{display:`${values.displey_none_status}`}}
                          onClick={() => openModal("tomar", values)}
                        >
                          <i className='fa fa-user-tag'></i>
                        </ButtonCustom>
                        <ButtonCustom 
                          classnames={`btn btn-sm btn-success text-white rounded m-1`}
                          popOver='Solucionar Caso'
                          style={{display:`${values.displey_none_solucion}`}}
                          onClick={() => openModal("solucionar", values)}
                        >
                          <i className='fa fa-book'></i>
                        </ButtonCustom>          
                        <ButtonCustom 
                          classnames={`btn btn-sm btn-danger text-white rounded m-1`}
                          popOver='Cancelar Caso'
                          style={{display:`${values.displey_none_cancelacion}`}}
                          onClick={() => openModal("cancelar", values)}
                        >
                          <i className='fa fa-ban'></i> 
                        </ButtonCustom>
                        <ButtonCustom 
                          classnames={`btn btn-sm btn-secondary text-white rounded m-1`}
                          popOver='Asignar Caso'
                          style={{display:`${values.displey_none_cancelacion}`}}
                          onClick={() => openModal("reasignar", values)}
                        >
                          <i className='fa fa-user-plus'></i> 
                        </ButtonCustom>
                        <ButtonCustom 
                          classnames={`btn btn-sm btn-comment text-white rounded m-1`}
                          popOver='Hacer Comentario'
                          style={{display:`${values.displey_none_comentario}`}}
                          onClick={() => openModal("comentar", values)}
                        >
                          <i className='fa fa-comment-dots'></i> 
                        </ButtonCustom>         
                        <ButtonCustom 
                          classnames={`btn btn-sm btn-warning2 text-white rounded m-1`}
                          popOver='Cotizar'
                          style={{display:`${values.displey_none_cotizacion}`}} 
                          onClick={() => openModal("cotizar", values)}
                        >
                          <i className='fa fa-money-bill'></i>
                        </ButtonCustom>                
                      </div>
                    </div>
                  </>
                )}
              </div>
              
              
            </div>          
          </div>
        </div>
      </div>
    </>
  )
}
